import React from "react";
import {Navigate} from "react-router-dom";
import {useAuthState} from "../context/AuthContext";
import {RouteInfo} from "./RouteHelper";
import {SuperAdmin} from "../accessLevel/SuperAdmin";
import ErrorPage, {ErrorType} from "../pages/ErrorPage/ErrorPage";

export default function PrivateRoute() {

    const state = useAuthState()


    return (
        <>
            {
                state.token === null
                && !state.loading
                    ?
                    <Navigate to={RouteInfo.Login.globalUrl}/>
                    :
                    state.token !== null && !state.loading ?
                        <SuperAdmin/>
                        :
                        state.token === null && state.loading ?
                            <ErrorPage
                                errorType={ErrorType.CONNECTING}
                                title="در حال اتصال به سرور"
                                subTitle="لطفا کمی صبر نمایید..."/>
                            :
                            <ErrorPage
                                errorType={ErrorType.NOT_ACCESS}
                                title="عدم دسترسی"
                                subTitle="دسترسی شما به این صفحه محدود شده است !"/>
            }
        </>
    )

}